import React from "react";
import "./TeamAdvisorCard.css";

const TeamAdvisorCard = ({ member }) => {
  return (
    <div className="team-advisor-card">
      <div className="team-advisor-image-wrap">
        <img
          src={member.image}
          alt={member.name}
          className="team-advisor-image"
        />
      </div>

      <h3 className="team-advisor-name">{member.name}</h3>
      <p className="team-advisor-description">{member.description}</p>
    </div>
  );
};

export default TeamAdvisorCard;